import React from 'react';
import PropTypes from 'prop-types';

const WalmartPlusLogo = ({ primary = true }) => {
  const imgSrc = `/images/walmart-plus-${primary ? 'primary' : 'secondary'}-sm.svg`;

  return <img src={imgSrc} alt="Walmart+" className="mr-1" />;
};

WalmartPlusLogo.propTypes = {
  primary: PropTypes.bool,
};

export default WalmartPlusLogo;
